import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import AsignacionesV2Service from "../services/asignacionesV2";

interface Props {
  psId: string | number;
  refreshKey?: number;
}

const headStyle: React.CSSProperties = { background: "#910434", color: "whitesmoke", fontWeight: "bold" };
const subHeadStyle: React.CSSProperties = { background: "#b06", color: "whitesmoke" };

// Columnas estilo EMSYS: tipo de hora -> clave del backend.
const COLUMNAS: { label: string; key: string }[] = [
  { label: "Sem. Diurna", key: "NORMA" },
  { label: "Sem. Nocturna", key: "HNOC" },
  { label: "Dom. Diurna", key: "DOMIN" },
  { label: "Dom. Nocturna", key: "DONOC" },
  { label: "Fer. Diurna", key: "FERIA" },
  { label: "Fer. Nocturna", key: "FENOC" },
  { label: "Total", key: "total" },
];

const val = (obj: any, key: string) => {
  if (!obj) return "-";
  const v = obj[key];
  if (v === undefined || v === null || v === "") return "-";
  return v;
};

// Resumen de cupos del punto de servicio (cupo total / asignado / restante)
// por tipo de hora, replicando la tabla resumen de EMSYS.
const ResumenCupos: React.FC<Props> = ({ psId, refreshKey }) => {
  const [cupos, setCupos] = useState<{ asignado: any; hora: any; restante: any }>({
    asignado: {},
    hora: {},
    restante: {},
  });

  useEffect(() => {
    (async () => {
      if (!psId) return;
      const data = await AsignacionesV2Service.cupos(psId);
      setCupos(data);
    })();
  }, [psId, refreshKey]);

  const filas = [
    { label: "Cupo de horas", obj: cupos.hora },
    { label: "Horas asignadas", obj: cupos.asignado },
    { label: "Horas restantes", obj: cupos.restante },
  ];

  return (
    <Paper style={{ width: "100%", overflowX: "auto" }}>
      <Typography variant="subtitle1" style={{ padding: "6px 12px", fontWeight: "bold", color: "#910434" }}>
        Resumen de horas
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={headStyle}>Totales</TableCell>
            {COLUMNAS.map((c) => (
              <TableCell key={c.key} style={subHeadStyle} align="center">
                {c.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filas.map((fila) => (
            <TableRow key={fila.label}>
              <TableCell style={{ fontWeight: "bold" }}>{fila.label}</TableCell>
              {COLUMNAS.map((c) => (
                <TableCell key={c.key} align="center">
                  {val(fila.obj, c.key)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ResumenCupos;
